import { Controller } from '@hotwired/stimulus'
import * as likely from 'ilyabirman-likely'

export default class extends Controller {
  connect () {
    likely.initiate()
  }
}
